export enum SocketEvents {
  Connect = 'connect',
  Disonnect = 'disconnect',
  Export = 'export',
  Error = 'error',
  PasswordNotification = 'passwordNotification',
  Plot = 'plot',
  ExportDXF = 'exportDXF',
  Logout = 'logout',
  AuthRequired = 'auth_required'
}
